import React from 'react';
import Tabs from './Tabs';

const SRGStreams = ({ streams, URN, onClickAction }) => {
  return (
    <>
      <h1 className="content__title">Sample Streams</h1>
      <Tabs>
        {Object.keys(streams).map(BU => {
          const buStreams = streams[BU];
          return (
            <div key={BU} label={BU}>
              <div className="tabs__panel">
                {buStreams.map(({ title, src }) => {
                  const activeClass = URN === src ? 'tabs__panel__item--active' : '';
                  return (
                    <div className={`tabs__panel__item ${activeClass}`} key={src} onClick={() => onClickAction(src)}>
                      {title}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </Tabs>
    </>
  );
};

export default SRGStreams;
